var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.popinPayload.results.length > 0)?_c('div',{staticClass:"list-results-container"},[_c('List',{attrs:{"showColumnsTitle":true,"columns":_vm.getColumns,"items":_vm.popinPayload.results,"orderable":false,"maxItems":0}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }